<script>
import { api } from "@/state/services";
export default {
  locales: {
    pt: {
      'You chose': 'Você escolheu',
      'Receive at Home': 'Receber em Casa',
      'You chose to pick up at': 'Você escolheu retirar em',
      'Change': 'Alterar',
      'Go to Virtual Office': 'Ir para o Escritório Virtual',
      'Choose a shipping option to receive your products.': 'Escolha uma opção de frete para receber os seus produtos.',
      'Select': 'Selecionar',
      'Pick up at Headquarters': 'Retirar na Sede',
      'Pick up at a Distribution Center': 'Retirar em um CD',
      'Choose a distribution center to pick up your products.': 'Escolha um CD para efetuar a retirada dos seus produtos.',
      'Select...': 'Selecione',
      'Contact': 'Entrar em Contato',
      'You are in the store of': 'Você está na loja de',
      'You have a discount of': 'Você possui um desconto de',
      'in the store of': 'na loja de',
      'Stores': 'Lojas',
      'Select the store': 'Selecione a loja',
      'Search': 'Buscar',
    },
    es: {
      'You chose': 'Elegiste',
      'Receive at Home': 'Recibir en Casa',
      'You chose to pick up at': 'Elegiste retirar en',
      'Change': 'Cambiar',
      'Go to Virtual Office': 'Ir a la Oficina Virtual',
      'Choose a shipping option to receive your products.': 'Elige una opción de envío para recibir tus productos.',
      'Select': 'Seleccionar',
      'Pick up at Headquarters': 'Retirar en la Sede',
      'Pick up at a Distribution Center': 'Retirar en un Centro de Distribución',
      'Choose a distribution center to pick up your products.': 'Elige un centro de distribución para retirar tus productos.',
      'Select...': 'Selecciona',
      'Contact': 'Contactar',
      'You are in the store of': 'Estás en la tienda de',
      'You have a discount of': 'Tienes un descuento de',
      'in the store of': 'en la tienda de',
      'Stores': 'Tiendas',
      'Select the store': 'Selecciona la tienda',
      'Search': 'Buscar',
    },
  },
  components: {},
  data() {
    return {
      franchise: {
        modal: false,
        list: null,
        receive: 1,
        withdraw: "",

        chosen: null,
        allowed: {
          receive: "inactive",
          withdrawal: "active",
        },
      },

      company: "",

      store: {
        progress: [],
        type: {
          id: null,
          name: null,
          price: null,
          discount: 0,
        },
        types: null,
        choose: {
          type: null,
          modal: false,
        },
      },

      search: {
        loading: false,
        value: this.$route.query.q,
      },
    };
  },
  methods: {
    getConfig() {
      api.get("store/config").then((response) => {
        if (response.data.status == "success") {
          if (response.data.franchise.status == "unselected") {
            this.franchise.modal = true;
          } else {
            this.franchise.chosen = response.data.franchise;
          }
          this.franchise.allowed = response.data.franchise.allowed;

          this.store.type = response.data.store.type;
          (this.store.progress = response.data.store.progress),
            (this.store.types = response.data.store.types);
          this.store.choose.type = this.store.type.id;
        }
      });
    },
    getFranchises() {
      api.get("store/franchises").then((response) => {
        if (response.data.status == "success") {
          this.franchise.list = response.data.list;
        }
      });
    },
    setReceive() {
      api
        .post("store/franchises", {
          id: this.franchise.receive,
          type: "receive",
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.franchise.modal = false;
            localStorage.removeItem("cart");
            this.$parent.getCart();
            this.getConfig();
            this.$parent.$parent.getProducts();
          }
        });
    },
    getCompany() {
      api.get("store/company").then((response) => {
        if (response.data.status == "success") {
          this.company = response.data.company;
        }
      });
    },
    setWithdrawCompany() {
      api
        .post("store/franchises", {
          id: this.franchise.receive,
          type: "withdraw",
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.franchise.modal = false;
            localStorage.removeItem("cart");
            this.$parent.getCart();
            this.getConfig();
            this.$parent.$parent.getProducts();
          }
        });
    },
    setWithdrawFranchise() {
      api
        .post("store/franchises", {
          id: this.franchise.withdraw,
          type: "withdraw",
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.franchise.modal = false;
            localStorage.removeItem("cart");
            this.$parent.getCart();
            this.getConfig();
            this.$parent.$parent.getProducts();
          }
        });
    },
    setStoreChange() {
      api
        .post("store/change", {
          type: this.store.choose.type,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.store.choose.modal = false;
            localStorage.removeItem("cart");
            this.$parent.getCart();
            this.getConfig();
            this.$parent.$parent.getProducts();
          }
        });
    },
    getPercent(from, to) {
      var total = this.total;
      if (total) {
        total = String(total).replace("R$ ", "");
        total = total.replace(/\./g, "").replace(",", ".");
        total = parseFloat(total);
        if (total - from < 0) {
          return 0;
        }
        if (((total - from) * 100) / (to - from) <= 100) {
          return (((total - from) * 100) / (to - from)).toFixed(0);
        } else {
          return 100;
        }
      } else {
        return 0;
      }
    },
    searchProduct() {
      if (this.search.value) {
        this.$router.push({ path: '/store/search', query: { q: this.search.value } })
      } else {
        this.$router.push('/store/featured');
      }
    }
  },
  mounted() {
    this.getConfig();
    this.getCompany();
    this.getFranchises();
  },
  props: {
    total: {
      default: "",
    },
  },
};
</script>

<template>
  <div class="mb-4">
    <div v-if="franchise.chosen" class="card mb-1">
      <div class="card-body py-3">
        <div class="d-flex align-items-center justify-content-between">
          <div style="line-height: 18px">
            <template v-if="franchise.chosen.type == 'receive'">
              {{ t('You chose') }}<br /><b>{{ t('Receive at Home') }}</b>
            </template>
            <template v-else>
              {{ t('You chose to pick up at') }}<br /><b>{{ franchise.chosen.name }}</b>
            </template>
          </div>
          <button class="btn btn-default btn-sm float-right m-1 text-uppercase" @click="franchise.modal = true">
            {{ t('Change') }}
          </button>
        </div>
      </div>
    </div>

    <b-modal v-model="franchise.modal" size="xl" no-close-on-backdrop hide-header hide-footer centered>
      <router-link tag="a" :to="'/'" class="text-dark"><i class="bx bx-arrow-back"></i> {{ t('Go to Virtual Office') }}</router-link>
      <hr />
      <div class="row mt-5 justify-content-center">
        <div class="col-lg-4" v-if="franchise.allowed.receive == 'active'">
          <div class="bg-soft-light rounded p-3 text-center mb-4">
            <img class="mb-3" width="80" src="@/assets/images/store-shipping.png" />
            <h4>{{ t('Receive at Home') }}</h4>
            <p>{{ t('Choose a shipping option to receive your products.') }}</p>
            <button class="btn btn-default btn-lg" v-on:click="setReceive()">
              {{ t('Select') }}
            </button>
          </div>
        </div>
        <div class="d-none col-lg-4">
          <div class="bg-soft-light rounded p-3 text-center mb-4">
            <img class="mb-3" width="80" src="@/assets/images/store-company.png" />
            <h4>{{ t('Pick up at Headquarters') }}</h4>
            <div v-if="company" class="mb-3 border bg-white rounded p-4 text-left">
              <h6 class="mb-0 d-flex">
                <i class="bx bxs-map font-size-20 align-middle"></i>
                <div class="ml-1">
                  {{ company }}
                </div>
              </h6>
            </div>
            <button class="btn btn-default btn-lg" v-on:click="setWithdrawCompany()">
              {{ t('Select') }}
            </button>
          </div>
        </div>
        <div class="col-lg-4" v-if="franchise.list">
          <div class="bg-soft-light rounded p-3 text-center">
            <img class="mb-3" width="80" src="@/assets/images/store-home.png" />
            <h4>{{ t('Pick up at a Distribution Center') }}</h4>
            <p>{{ t('Choose a distribution center to pick up your products.') }}</p>
            <form @submit.prevent="setWithdrawFranchise">
              <select v-model="franchise.withdraw" class="form-control mb-3" id="exampleFormControlSelect1">
                <option value="">{{ t('Select...') }}</option>
                <option v-for="fra in franchise.list" :value="fra.id" :key="fra.id">
                  {{ fra.name }}
                </option>
              </select>
              <div v-if="franchise.withdraw" class="mb-3 border bg-white rounded p-4 text-left">
                <h6 class="mb-0">
                  <i class="bx bx-user-pin font-size-20 align-middle"></i>
                  {{ franchise.list[franchise.withdraw].responsible }}
                </h6>
                <h6 class="mb-0" v-if="franchise.list[franchise.withdraw].email">
                  <i class="bx bx-mail-send font-size-20 align-middle"></i>
                  {{ franchise.list[franchise.withdraw].email }}
                </h6>
                <h6 class="mb-0" v-if="franchise.list[franchise.withdraw].cellphone">
                  <i class="bx bx-microphone font-size-20 align-middle"></i>
                  {{ franchise.list[franchise.withdraw].cellphone }}
                </h6>
                <a v-if="franchise.list[franchise.withdraw].cellphone" class="btn btn-xs btn-block btn-success ml-1 p-1 pl-1 pr-1 pb-1" target="_blank" :href="'https://wa.me/55' + franchise.list[franchise.withdraw].cellphone.replace(/[^0-9]/g, '')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 2 24 20" style="fill: rgba(255, 255, 255, 1);">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                    </path>
                  </svg>
                  <span class="ml-1">{{ t('Contact') }}</span>
                </a>
                <h6 class="mt-3 mb-0 d-flex">
                  <i class="bx bxs-map font-size-20 align-middle"></i>
                  <div class="ml-1">
                    {{ franchise.list[franchise.withdraw].company.address }},
                    {{ franchise.list[franchise.withdraw].company.number
                    }}<template>,
                      {{
                      franchise.list[franchise.withdraw].company.complement
                      }}</template><br />
                    {{ franchise.list[franchise.withdraw].company.district }},
                    {{ franchise.list[franchise.withdraw].company.city }}/{{
                    franchise.list[franchise.withdraw].company.state
                    }},
                    {{ franchise.list[franchise.withdraw].company.zipcode }},
                    {{ franchise.list[franchise.withdraw].company.country }}
                  </div>
                </h6>
              </div>
              <button class="btn btn-default btn-lg" :disabled="!franchise.withdraw">
                {{ t('Select') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <div v-if="store.type.id" class="card mb-0">
      <div class="card-body py-2">
        <div class="d-flex align-items-center justify-content-between">
          <p class="text-left m-0">
            {{ t('You are in the store of') }} <b>{{ store.type.name }}</b>
          </p>
          <button class="btn btn-default btn-sm float-right m-1 text-uppercase" @click="store.choose.modal = true">
            {{ t('Change') }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="store.type && store.type.discount && store.type.discount > 0">
      <div class="card my-1">
        <div class="card-body py-3 bg-soft-info">
          <div class="d-flex align-items-center justify-content-between">
            <p class="text-left m-0">
              {{ t('You have a discount of') }} <b>{{ store.type.discount | currency }}</b> {{ t('in the store of') }} <b>{{ store.type.name }}.</b>
            </p>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="store.choose.modal" :title="t('Stores')" hide-footer centered>
      <div class="form-group">
        <form @submit.prevent="setStoreChange">
          <label for="exampleFormControlSelect1">{{ t('Select the store') }}</label>
          <select v-model="store.choose.type" class="form-control" id="exampleFormControlSelect1">
            <option v-for="(type, index) in store.types" :value="type.id" :key="index">
              {{ type.name }}
            </option>
          </select>
          <button class="btn btn-default text-uppercase mt-2" type="submit">
            {{ t('Change') }}
          </button>
        </form>
      </div>
    </b-modal>

    <div v-if="store.progress && store.progress.length > 0" id="store-progress" class="card mt-1 mb-0">
      <div class="card-body py-3">
        <div class="d-flex">
          <div class="flex-fill" v-for="(row, index) in store.progress" :key="index">
            <div class="progress" style="height: 25px">
              <div clas="progress-bar progress-bar-animated" :class="row.color" role="progressbar" :style="'height: 25px; width:' +
                getPercent(row.value.from, row.value.to) +
                '%'
                " :aria-valuenow="getPercent(row.value.from, row.value.to)" :aria-valuemin="0" :aria-valuemax="100"></div>
            </div>
            <div class="d-md-flex justify-content-between font-size-12 pt-1">
              <div class="px-1">{{ row.name }}</div>
              <div class="px-1">
                {{ getPercent(row.value.from, row.value.to) }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="store.type.id" class="card mt-1 mb-0">
      <div class="card-body py-3">
        <b-form @submit.prevent="searchProduct">
          <b-form-group class="m-0" label-for="search.value">
            <b-input-group>
              <b-form-input v-model="search.value" type="text"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="search.loading == true" type="submit" variant="default" class="btn-block">
                  {{ t('Search') }}
                  <b-spinner v-if="search.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<style>
#store-progress .progress {
  border-radius: 0;
}
#store-progress .flex-fill:first-child .progress {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
#store-progress .flex-fill:last-child .progress {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
</style>